import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { routerGuard } from "./guard/router-guard.service";

const routes: Routes = [
  { path: '',
    redirectTo: '/404',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: PageNotFoundComponent
  },
  {
    path: 'venda-deslogada',
    loadChildren: () => import('./disconnected-sale/disconnected-sale.module').then(m => m.DisconnectedSaleModule)
  },
  {
    path: 'auto-atendimento',
    loadChildren: () => import('./self-attendance/self-attendance.module').then(m => m.SelfAttendanceModule)
  },
  {
    path: 'desenvolvimento',
    loadChildren: () => import('./development/development.module').then(m => m.DevelopmentModule)
  },
  {
    path: ':classificationIdentifier',
    canActivate: [routerGuard],
    loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    enableTracing: false
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
